const getDisabledField = (documentNumber, commercialName) => {
  if (documentNumber?.length > 8 && commercialName?.length >= 1) return false;
  return true;
};

export default getDisabledField;
